module.exports = __webpack_public_path__ + "static/profile-pic-7e46fb11a955b4d9647f663b90769bbd.png";